import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ReceiptStudentPageRoutingModule } from './receipt-student-routing.module';

import { ReceiptStudentPage } from './receipt-student.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReceiptStudentPageRoutingModule
  ],
  declarations: [ReceiptStudentPage]
})
export class ReceiptStudentPageModule {}
